import Business from "@material-ui/icons/Business";
import AssignmentTurnedIn from "@material-ui/icons/AssignmentTurnedIn";
import Timeline from "@material-ui/icons/Timeline";

// TODO: Mejorar la redacción de misión y visión
const services = [
  {
    title: "La Empresa",
    icon: Business,
    description: `Vivamos el Campo SAS (NIT No 901128377-0 y RNT 135625) es un Operador de Plataformas
    Electrónicas o Digitales de Servicios Turísticos (Ley 2068 de 2020) dedicada al Turismo Rural,
    siendo pionera en promover y ofrecer servicios de este tipo en Colombia. Nos especializamos en
    la intermediación y operación entre dos sectores de usuarios: Los propietarios de alojamientos
    rurales y Prestadores de Servicios Turísticos (PST) con RNT, conectándolos con turistas
    nacionales y extranjeros. Nuestro objetivo es brindar una experiencia única y auténtica,
    conectando a los viajeros con la belleza natural y cultural de las zonas rurales de Colombia.`
  },
  {
    title: "Misión",
    icon: AssignmentTurnedIn,
    description: `Realizar una conexión comercial online entre los propietarios de Alojamientos
    Rurales que cuenten con Registro Nacional de Turismo (RNT), los artesanos, servicios conexos,
    y también con los Turistas Nacionales y Extranjeros, de tal forma que podamos fomentar el
    Turismo Rural respetando el valor cultural y ambiental de cada uno de los alojamientos y
    destinos turísticos, haciéndolos sostenibles y colaborando en el desarrollo social del sector
    en el cual se desarrolla el Turismo Rural.`
  },
  {
    title: "Visión",
    icon: Timeline,
    description: `Expandirnos con el fin de llegar a todos los lugares en los cuales se presten
    servicios de Turismo Rural, buscando ser líderes en la promoción de Alojamientos y Servicios
    Turísticos Rurales en el territorio Colombiano, y por que no, en el extranjero. Vivamos el Campo
    espera ser un aliado de las instituciones que impulsen y generen conocimiento relacionado con
    buenas prácticas a la hora de prestar actividades turísticas y de hospedaje, buscando ser un
    promotor de los procesos de legalización de los Prestadores de Servicios Turísticos, esperando
    convertirse así en un ente capacitador para los Propietarios de Alojamientos Rurales.`
  }
];

export default services;



// WEBPACK FOOTER //
// ./src/views/AboutUsPage/assets/services.js